import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  showForm: false,
  showLocationData: false,
  editingLocation: null,
};

const locationSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {
    setShowForm: (state, action) => {
      state.showForm = action.payload;
    },
    setShowLocationData: (state, action) => {
      state.showLocationData = action.payload;
    },
    setEditingLocation: (state, action) => {
      state.editingLocation = action.payload;
    },
  },
});

export const {
  setShowForm,
  setShowLocationData,
  setEditingLocation,
} = locationSlice.actions;

export default locationSlice.reducer;
